import JobPictureApi from '~/common/api/zeiterfassungServerApi/JobPictureApi';
import { Heading } from '~/common/components/defaultUIComponents/Heading';
import useTranslate from '~/common/utils/translate';
import { Badge, Box } from '@chakra-ui/react';
import { NewImageList } from './NewImageList';
import React from 'react';

export const NewImages: React.FC = () => {
  const translate = useTranslate();
  const [{ data: unacceptedPicturesCount }] =
    JobPictureApi.hooks.useUnacceptedPicturesCount({
      refetchInterval: 1000 * 60,
    });
  return (
    <Box>
      <Heading mb={5}>
        {translate('dashboard.newimages.heading')}
        <Badge
          marginLeft={5}
          variant="outline"
          colorScheme="green"
          fontSize={25}
        >
          {unacceptedPicturesCount?.count ?? 0}
        </Badge>
      </Heading>
      <NewImageList />
    </Box>
  );
};
